import { action } from 'typesafe-actions';
import {
  WORLD_CUP_RANKINGS_FAILURE,
  WORLD_CUP_RANKINGS_REQUEST,
  WORLD_CUP_RANKINGS_SUCCESS,
} from '../../constants/worldCupRankings';

export const worldCupRankingsRequestAction = () =>
  action(WORLD_CUP_RANKINGS_REQUEST);
export const worldCupRankingsSuccessAction = (data: any) =>
  action(WORLD_CUP_RANKINGS_SUCCESS, data.competition_ranking);
export const worldCupRankingsFailureAction = (e: any) =>
  action(WORLD_CUP_RANKINGS_FAILURE, e);

export const worldCupRankingsActions = {
  worldCupRankingsRequestAction,
  worldCupRankingsSuccessAction,
  worldCupRankingsFailureAction,
};
